import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../components/Layout';
import './Round.css';

const ITEMS = [
  { src: '/movie/Anar.jpg', answer: 'Anar' },
  { src: '/movie/Chakra1.jpg', answer: 'Chakra' },
  { src: '/movie/Rocket.png', answer: 'Diwali Rocket' },
  { src: '/movie/bomb.jpg', answer: 'Sutali Bomb' },
];

export default function BlurryImages() {
  const navigate = useNavigate();
  const [revealed, setRevealed] = useState(false);

  return (
    <Layout round="Round 3" title="Identify types of fire crackers from the blurry images">
      <div className="blurry-grid">
        {ITEMS.map((item, idx) => (
          <div className="blurry-item" key={idx}>
            <img
              src={item.src}
              alt={item.answer}
              className={revealed ? 'clear-img' : 'blur-img'}
            />
            {revealed && <p className="blurry-answer">{item.answer}</p>}
          </div>
        ))}
      </div>

      {!revealed ? (
        <button className="hunt-btn" onClick={() => setRevealed(true)}>
          Reveal Answer
        </button>
      ) : (
        <button className="hunt-btn" onClick={() => navigate('/thankyou')}>
          Next
        </button>
      )}
    </Layout>
  );
}
